import { Ref } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";

export default function useIntersectionObserver({
  elementRef,
  callback,
  threshold,
}: {
  elementRef: Ref<HTMLElement | null>;
  callback: () => void | Promise<void>;
  threshold?: number;
}) {
  let observer: IntersectionObserver | null = null;
  const setupIntersectionObserver = () => {
    if (!elementRef.value) return;

    observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            callback();
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: threshold ?? 0.1,
      }
    );

    observer.observe(getElement(elementRef.value));
  };

  const cleanupIntersectionObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  return { setupIntersectionObserver, cleanupIntersectionObserver };
}
